module.exports = __webpack_public_path__ + "img/xero.4eb0566b.png";